import { useSyncExternalStore } from 'react'
import { RoomStateItem } from '../../../types/state'
import { RoomEvent } from '../../constants/enums'
import { isLounge } from '../../mfcLogic/userProperties/user'
import { ROOMSSTATE } from '../../state'
import { getRoomsState } from '../../state/getState'
import { pubSubRooms } from '../../state/pubSub'
import { useUserSelector } from './useUser'

const getRoomsRestored = () => ROOMSSTATE.restored
export const getPinnedRooms = () => ROOMSSTATE.pinnedRooms
export const getPinnedRoomCount = () => ROOMSSTATE.pinnedRooms.length
export const getIsRoomPinned = (id: number) => () =>
    !id ? false : ROOMSSTATE.pinnedRooms.includes(id)
export const getPinHelperID = () => ROOMSSTATE.pinHelperID

export const resolveRoomStateSelector =
    <T extends keyof RoomStateItem>(id: number, attribute: T) =>
    (): RoomStateItem[T] => {
        const state = getRoomsState()[id] || { isLounge: isLounge(id), id }
        return state[attribute]
    }

const subPinnedRooms = (callback: () => void) =>
    pubSubRooms.on(RoomEvent.PIN_ROOM, callback)
const subPinHelperID = (callback: () => void) =>
    pubSubRooms.on(RoomEvent.PIN_HELPER_ID, callback)
const subRestored = (callback: () => void) =>
    pubSubRooms.on(RoomEvent.RESTORED, callback)
export const subRoom = (callback: () => void) =>
    pubSubRooms.on(RoomEvent.STATE, callback)

export const useRoomRestored = () => {
    return useSyncExternalStore(subRestored, getRoomsRestored, getRoomsRestored)
}

export const usePinnedRooms = () => {
    const pinnedRooms = useSyncExternalStore(
        subPinnedRooms,
        getPinnedRooms,
        getPinnedRooms,
    )

    return pinnedRooms
}
export const useIsRoomPinned = (id: number) => {
    const isRoomPinned = useSyncExternalStore(
        subPinnedRooms,
        getIsRoomPinned(id),
        getIsRoomPinned(id),
    )

    return isRoomPinned
}
export const usePinnedRoomCount = () => {
    const pinnedRoomCount = useSyncExternalStore(
        subPinnedRooms,
        getPinnedRoomCount,
        getPinnedRoomCount,
    )

    return pinnedRoomCount
}
export const usePinHelperUser = () => {
    const pinHelperID = useSyncExternalStore(
        subPinHelperID,
        getPinHelperID,
        getPinHelperID,
    )
    const isFriend = useUserSelector(pinHelperID, 'isFriend')
    const isBookmark = useUserSelector(pinHelperID, 'isBookmark')
    return { id: pinHelperID, isFriend, isBookmark }
}

export const useRoomSelector = <T extends keyof RoomStateItem>(
    id: number,
    attribute: T,
): RoomStateItem[T] => {
    return useSyncExternalStore(
        subRoom,
        resolveRoomStateSelector(id, attribute),
        resolveRoomStateSelector(id, attribute),
    )
}

// MFC's own lounges, and member rooms in lounge style, which only room state marks
export const useIsLoungeRoom = (id: number) => {
    const roomLounge = useRoomSelector(id, 'isLounge')
    return isLounge(id) || !!roomLounge
}
